import { query, request } from '@/utils/request';

export const getContractDetail = params => {
  return request('/zlb/api/expense/contract/v3/detail', { method: 'GET', params });
};

// 创建合同
export const createContract = params => {
  return request(`/zlb/api/expense/contract/v3/create`, {
    method: 'POST',
    data: params,
  });
};

// 完成合同
export const completeContractRq = params => {
  return request(`/zlb/api/expense/contract/v3/complete`, {
    method: 'POST',
    data: params,
  });
};

// 合同变更
export const submitChange = params => {
  return request(`/zlb/api/expense/contract/v3/change/submit`, {
    method: 'POST',
    data: params,
  });
};

// 更新合同付款计划
export const updatePaymentPlan = params => {
  return request(`/zlb/api/expense/contract/v3/period/saveOrUpdate`, {
    method: 'POST',
    data: params,
  });
};

// 获取计划详情
export const getPaymentPlanDetailAll = params => {
  return request(`/zlb/api/expense/contract/v3/payDetail`, {
    method: 'GET',
    params,
  });
};

// 获取合同付款计划详情
export const getPaymentPlanDetail = params => {
  return request(`/zlb/api/expense/contract/v3/period/detail`, {
    method: 'GET',
    params,
  });
};

// 删除合同付款计划
export const deletePaymentPlan = id => {
  return request(`/zlb/api/expense/contract/v3/period/${id}`, {
    method: 'DELETE',
  });
};

// 提交合同
export const submitContractChange = params => {
  return request(`/zlb/api/expense/contract/v3/change/submit`, {
    method: 'POST',
    data: params,
  });
};

// 获取合同变更详情
export const getContractChangeDetail = params => {
  return request(`/zlb/api/expense/contract/v3/change/detail`, {
    method: 'GET',
    params,
  });
};

// 获取合同变更记录
export const getContractChangeList = params => {
  return request(`/zlb/api/expense/contract/v3/change/list`, {
    method: 'POST',
    data: params,
  });
};

//删除合同
export const deleteContract = id => {
  return request(`/zlb/api/expense/contract/v3/delete/${id}`, {
    method: 'DELETE',
  });
};

// 纠纷调节列表查询
export const getContractMediationList = data => {
  return query('/zlb/api/expense/contract/mediation/list', {
    method: 'POST',
    data,
  });
};

// 获取合同审批记录
export const getApprovalRecordList = params => {
  return request(`/zlb/api/expense/contract/v3/approveList`, {
    method: 'POST',
    data: params,
  });
};

// 合同验收审批合同状态更新
export const submitContractAcceptance = data => {
  return query('/zlb/api/expense/contract/v3/acceptance/submit', {
    method: 'POST',
    data,
  });
};

// 合同关联报销单
export const getContractAssociationForm = params => {
  return query('/zlb/api/expense/contract/v3/expense/form/rel', {
    params,
  });
};

// 上传银行回单附件
export const createBankRecord = params => {
  return request(`/zlb/api/expense/contract/v3/bank/receipt/create`, {
    method: 'POST',
    data: params,
  });
};

// 添加验收记录
export const addAcceptanceRecord = params => {
  return request(`/zlb/api/expense/contract/acceptance/save`, {
    method: 'POST',
    data: params,
  });
};

// 查看验收记录详情
export const getAcceptanceRecordDetail = params => {
  return request(`/zlb/api/expense/contract/acceptance/detail`, {
    method: 'GET',
    params,
  });
};

// 删除验收记录
export const deleteAcceptanceRecord = id => {
  return request(`/zlb/api/expense/contract/acceptance//${id}`, {
    method: 'DELETE',
  });
};

// 创建收款计划
export const createReceiverPlan = params => {
  return request(`/zlb/api/expense/contract/v3/receiver/create`, {
    method: 'POST',
    data: params,
  });
};
